import { useEffect, useRef, useState } from 'react';

export const useGreedyNav = () => {
  const navRef = useRef<HTMLDivElement>(null);
  const moreButtonRef = useRef<HTMLButtonElement>(null);
  const visibleItemsRef = useRef<HTMLDivElement>(null);
  const [breaks, setBreaks] = useState<number[]>([]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const navWidth = navRef.current?.clientWidth || 0;
      const visibleItemsWidth = visibleItemsRef.current?.clientWidth || 0;
      const moreButtonWidth = moreButtonRef.current?.clientWidth || 0;
      const freeSpace = breaks.length ? navWidth - moreButtonWidth : navWidth;
      if (visibleItemsWidth > freeSpace) {
        /** This should trigger a re-render and go through that useEffect again */
        setBreaks(b => {
          return [...b, freeSpace];
        });
      } else {
        setBreaks(b => {
          /** This should trigger a re-render and go through that useEffect again */
          if (freeSpace > b[b.length - 1]) {
            return b.slice(0, -1);
          }
          /** The loop of rerender ends here, since it returns the same reference */
          return b;
        });
      }
    });
    if (navRef.current && visibleItemsRef.current) {
      resizeObserver.observe(navRef.current);
      resizeObserver.observe(visibleItemsRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  });

  return {
    navRef,
    visibleItemsRef,
    moreButtonRef,
    itemsToHide: breaks.length,
  };
};
